export default __webpack_public_path__ + "static/media/mpin-err.fce6e39d.svg";